import config from "../../../config";
import axiosInstance from "../../../services/AxiosInstance";
import { createProgressNote } from "../../../services/NoteService";

export const NOTE_ACTIONS = {
  SAVE_NOTE_REQUEST: "SAVE_NOTE_REQUEST",
  SAVE_NOTE_SUCCESS: "SAVE_NOTE_SUCCESS",
  SAVE_NOTE_FAILURE: "SAVE_NOTE_FAILURE",
  DELETE_NOTE_REQUEST: "DELETE_NOTE_REQUEST",
  DELETE_NOTE_SUCCESS: "DELETE_NOTE_SUCCESS",
  DELETE_NOTE_FAILURE: "DELETE_NOTE_FAILURE",
  LOAD_NOTES_REQUEST: "LOAD_NOTES_REQUEST",
  LOAD_NOTES_SUCCESS: "LOAD_NOTES_SUCCESS",
  LOAD_NOTES_FAILURE: "LOAD_NOTES_FAILURE",
  UPDATE_NOTE_REQUEST: "UPDATE_NOTE_REQUEST",
  UPDATE_NOTE_SUCCESS: "UPDATE_NOTE_SUCCESS",
  UPDATE_NOTE_FAILURE: "UPDATE_NOTE_FAILURE",
};

// Action creators
export const saveNoteRequest = () => ({
  type: NOTE_ACTIONS.SAVE_NOTE_REQUEST,
});

export const saveNoteSuccess = (noteData) => ({
  type: NOTE_ACTIONS.SAVE_NOTE_SUCCESS,
  payload: noteData,
});

export const saveNoteFailure = (error) => ({
  type: NOTE_ACTIONS.SAVE_NOTE_FAILURE,
  payload: error,
});

export const updateNoteRequest = () => ({
  type: NOTE_ACTIONS.UPDATE_NOTE_REQUEST,
});

export const updateNoteSuccess = (noteData) => ({
  type: NOTE_ACTIONS.UPDATE_NOTE_SUCCESS,
  payload: noteData,
});

export const updateNoteFailure = (error) => ({
  type: NOTE_ACTIONS.UPDATE_NOTE_FAILURE,
  payload: error,
});

export const deleteNoteRequest = () => ({
  type: NOTE_ACTIONS.DELETE_NOTE_REQUEST,
});

export const deleteNoteSuccess = (noteId, progressId, noteType) => ({
  type: NOTE_ACTIONS.DELETE_NOTE_SUCCESS,
  payload: { noteId, progressId, noteType },
});

export const deleteNoteFailure = (error) => ({
  type: NOTE_ACTIONS.DELETE_NOTE_FAILURE,
  payload: error,
});

export const loadNotesRequest = () => ({
  type: NOTE_ACTIONS.LOAD_NOTES_REQUEST,
});

export const loadNotesSuccess = (notes) => ({
  type: NOTE_ACTIONS.LOAD_NOTES_SUCCESS,
  payload: notes,
});

export const loadNotesFailure = (error) => ({
  type: NOTE_ACTIONS.LOAD_NOTES_FAILURE,
  payload: error,
});

// Thunk actions
export const saveNote = (noteData) => {
  return async (dispatch, getState) => {
    dispatch(saveNoteRequest());

    try {
      // API call to save note using your existing service
      const response = await createProgressNote(noteData);

      // Axios returns data directly in response.data
      console.log("Axios response:", response);
      console.log("Axios response data:", response.data);

      // The API response should have the note data in result field
      const noteResult = response.data.result || response.data;

      console.log("Note result to dispatch:", noteResult);

      dispatch(saveNoteSuccess(noteResult));

      return noteResult;
    } catch (error) {
      console.error("Save note error:", error);

      // Handle Axios error response
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to save note";

      dispatch(saveNoteFailure(errorMessage));
      throw new Error(errorMessage);
    }
  };
};

export const updateNote = (noteId, noteData) => {
  return async (dispatch, getState) => {
    dispatch(updateNoteRequest());

    try {
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;

      // You'll need to create an update service function similar to createProgressNote
      const response = await axiosInstance({
        url: `${config.routes.updateProgressNote}/${noteId}`, // Adjust route as needed
        method: "put",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: noteData,
      });

      console.log("Update response:", response);
      console.log("Update response data:", response.data);

      const noteResult = response.data.result || response.data;
      dispatch(updateNoteSuccess(noteResult));

      return noteResult;
    } catch (error) {
      console.error("Update note error:", error);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to update note";

      dispatch(updateNoteFailure(errorMessage));
      throw new Error(errorMessage);
    }
  };
};

export const deleteNote = ({ noteId, progressId, noteType }) => {
  return async (dispatch, getState) => {
    dispatch(deleteNoteRequest());

    try {
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;

      // API call to delete note using axios
      const response = await axiosInstance({
        url: `${config.routes.deleteProgressNote}/${noteId}`, // Adjust route as needed
        method: "delete",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Delete response:", response);

      dispatch(deleteNoteSuccess(noteId, progressId, noteType));
    } catch (error) {
      console.error("Delete note error:", error);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to delete note";

      dispatch(deleteNoteFailure(errorMessage));
      throw new Error(errorMessage);
    }
  };
};

export const loadNotes = (businessId) => {
  return async (dispatch, getState) => {
    dispatch(loadNotesRequest());

    try {
      const state = getState();
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;

      // API call to load notes
      const response = await fetch(
        `${config.appUrl}/business-progress/note/${businessId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to load notes");
      }

      const notesResponse = await response.json();

      // Transform the flat array into organized structure by progress_id and note_type
      const organizedNotes = {};

      if (notesResponse.result && Array.isArray(notesResponse.result)) {
        notesResponse.result.forEach((note) => {
          const progressId = note.progress_id;
          const noteType = note.note_type;

          if (!organizedNotes[progressId]) {
            organizedNotes[progressId] = {};
          }

          organizedNotes[progressId][noteType] = {
            id: note.id,
            text: note.note,
            author: note.author_id,
            timestamp: note.created_at,
            lastModified: note.updated_at,
            lang: note.lang,
            businessId: note.business_id,
            progressId: note.progress_id,
            noteType: note.note_type,
          };
        });
      }

      dispatch(loadNotesSuccess(organizedNotes));

      return organizedNotes;
    } catch (error) {
      dispatch(loadNotesFailure(error.message));
      throw error;
    }
  };
};
